window.addEventListener('aftermetoo_glossary_ready', () => {
	const highlights = [...document.querySelectorAll('.highlight')];
	// Leave room for the close button outside the card and its keyboard focus ring.
	const viewportPadding = 20;
	const tooltipGap = 14;

	function closeToolTips(current, restoreFocus = false) {
		let focusTarget;
		highlights.forEach((highlight) => {
			const button = highlight.querySelector(':scope > button');
			if (highlight !== current && button) {
				if (highlight.classList.contains('show')) focusTarget = button;
				highlight.classList.remove('show');
				button.setAttribute('aria-expanded', 'false');
			}
		});
		if (restoreFocus) focusTarget?.focus({ preventScroll: true });
		return Boolean(focusTarget);
	}

	function positionTooltip(highlight) {
		const tooltip = highlight.querySelector(':scope > .tooltip');
		if (!tooltip || !highlight.classList.contains('show')) return;
		const description = tooltip.querySelector('.tooltip__content');
		const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
		const viewportHeight = document.documentElement.clientHeight || window.innerHeight;
		const anchor = highlight.getBoundingClientRect();

		// Recompute from the stylesheet, rather than accumulating resize offsets.
		['left', 'right', 'top', 'bottom', 'transform'].forEach((property) => {
			tooltip.style.removeProperty(property);
		});
		if (description) {
			description.style.removeProperty('max-height');
			description.style.removeProperty('overflow-y');
		}

		let bounds = tooltip.getBoundingClientRect();
		const availableHeight = viewportHeight - viewportPadding * 2;
		if (description && bounds.height > availableHeight) {
			const contentHeight = description.getBoundingClientRect().height;
			description.style.maxHeight = `${Math.max(40, contentHeight - (bounds.height - availableHeight))}px`;
			description.style.overflowY = 'auto';
			bounds = tooltip.getBoundingClientRect();
		}

		// Include the protruding close button and shadow in the right-hand clearance.
		const maxLeft = Math.max(viewportPadding, viewportWidth - bounds.width - viewportPadding);
		const left = Math.min(Math.max(bounds.left, viewportPadding), maxLeft);
		let top = anchor.top - bounds.height - tooltipGap;
		if (top < viewportPadding) top = anchor.bottom + tooltipGap;
		top = Math.max(viewportPadding, Math.min(top, viewportHeight - bounds.height - viewportPadding));

		tooltip.style.left = `${left - anchor.left}px`;
		tooltip.style.right = 'auto';
		tooltip.style.top = `${top - anchor.top}px`;
		tooltip.style.bottom = 'auto';
		tooltip.style.transform = 'none';
	}

	highlights.forEach((highlight) => {
		const button = highlight.querySelector(':scope > button');
		const tooltip = highlight.querySelector(':scope > .tooltip');
		if (!button || !tooltip) return;

		button.addEventListener('click', (event) => {
			event.preventDefault();
			const opening = !highlight.classList.contains('show');
			closeToolTips();
			if (opening) {
				highlight.classList.add('show');
				button.setAttribute('aria-expanded', 'true');
				positionTooltip(highlight);
			}
		});

		tooltip.querySelector('.close')?.addEventListener('click', (event) => {
			event.preventDefault();
			closeToolTips(undefined, true);
		});
	});

	window.addEventListener('click', (event) => {
		if (!event.target.closest('.highlight')) closeToolTips();
	});

	window.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' && closeToolTips(undefined, true)) event.preventDefault();
	});

	window.addEventListener('resize', () => {
		highlights.forEach(positionTooltip);
	});
});
